var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("d2-container", [
    _c("div", { staticClass: "top" }, [
      _c("h4", { domProps: { innerHTML: _vm._s(_vm.h4title) } }),
      _c("div", { staticClass: "top_tu" }, [_c("d2-echart")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }